import { QualityApprovalStatus } from "@/graphql/codegen/graphql"

export enum TaskViewScope {
  MyTasks = "MY_TASKS",
  AllTasks = "ALL_TASKS",
}

export const PENDING_APPROVALS_ROUTE = "/app/dashboard/_layout/pending-approvals/_layout" as const

export const QUALITY_APPROVAL_STATUS_TO_LABEL: Record<QualityApprovalStatus, string> = {
  [QualityApprovalStatus.Pending]: "Pending",
  [QualityApprovalStatus.Approved]: "Approved",
  [QualityApprovalStatus.Denied]: "Denied",
  [QualityApprovalStatus.Canceled]: "Canceled",
}
